module.exports = __webpack_public_path__ + "static/media/new-york-11.682ff5cf.jpg";